export const populationPctTitle = 'Population share'
export const populationPctShortLabel = '% of population'
